
<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">اطلاعات کارکرد  تجهیز بهفا</h5>
     <br/>

     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">(شروع بازه) خروج </label>
        <input type="text" #datepickerInputStartDaryaft placeholder="اینجا تایپ کنید ..."   class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStartDaryaft"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">(پایان بازه) خروج  </label>
        <input type="text" #datepickerInputEndDaryaft  placeholder="اینجا تایپ کنید ..."  class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEndDaryaft"></ng-persian-datepicker>
      </div>
      </div>
     <br>
     <br>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">(شروع بازه) ورود   </label>
        <input type="text" #datepickerInputStartTahvil placeholder="اینجا تایپ کنید ..."   class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStartTahvil"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">(پایان بازه) ورود </label>
        <input type="text" #datepickerInputEndTahvil  placeholder="اینجا تایپ کنید ..."  class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEndTahvil"></ng-persian-datepicker>
      </div>
      </div>
     <br>
     <br>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Code BEHFA</label>
        <input [(ngModel)]="Filter_Code_BEHFA" (keyup)="Change_Filter()" name="Filter_Code_BEHFA" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> کاربر </label>
        <select class="custom-select" [(ngModel)]="selectedUser" >
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_User" [value]="item.username">
            {{item.name}} {{item.familly}}
          </option>
        </select>
      </div>

    </div>
     <div class="row">
      <div  class="form-group col-md-12" >
        <button  type="button" (click)="ReadData_DeviceBehfa(datepickerInputStartDaryaft.value,datepickerInputEndDaryaft.value,datepickerInputStartTahvil.value,datepickerInputEndTahvil.value)" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button (click)="exportexcel()" type="button"  class="btn btn-warning" style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>

     </div>

     <br>
     <br>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شماره رسید</th>
              <th>نام مشتری</th>
              <th>زمان مصرف</th>
              <th>Group</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>Certificate No.</th>
              <th>Cal. Due</th>
              <th>نام کاربر</th>
              <th>تاریخ دریافت</th>
              <th>تاریخ تحویل</th>
              <th>تصدیق کننده</th>
              <th>تاریخ تصدیق</th>
              <th>توضیحات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfa
            |filter:Filter_Code_BEHFA:'codeBEHFA'
            |filter:Filter_Code_User:'username'
            |filter:Filter_Code_Group:'groupTitle'
            | paginate
                    : {
                        id: 'DataList_DeviceBehfaTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (
                          DataList_DeviceBehfa
                          |filter:Filter_Code_BEHFA:'codeBEHFA'
                          |filter:Filter_Code_User:'username'
                          |filter:Filter_Code_Group:'groupTitle'
                          ).length
                      }
            " >
            <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
            <td>{{item.code}}</td>
            <td>{{item.customerName}}</td>
            <td>{{item.persianDate}}</td>
            <td>{{item.groupTitle}}</td>
            <td>{{item.description}}</td>
            <td>{{item.manufacturer}}</td>
            <td>{{item.model}}</td>
            <td>{{item.codeBEHFA}}</td>
            <td>{{item.certificateNo}}</td>
            <td>{{item.calDue}}</td>
            <td>{{item.username}}</td>
            <td>{{item.downloadDate}}</td>
            <td>{{item.uploadDate}}</td>
            <td>{{item.confirmer}}</td>
            <td>{{item.confirmerDate}}</td>
            <td>{{item.dsc}}</td>
            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_DeviceBehfaTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>



<table id="excel-table" style="display: none;" >
  <thead >
    <tr>
      <th>#</th>
      <th>شماره رسید</th>
      <th>نام مشتری</th>
      <th>زمان مصرف</th>
      <th>Group</th>
      <th>Description</th>
      <th>Manufacturer</th>
      <th>Model</th>
      <th>Code BEHFA</th>
      <th>Certificate No.</th>
      <th>Cal. Due</th>
      <th>نام کاربر</th>
      <th>تاریخ دریافت</th>
      <th>تاریخ تحویل</th>
      <th>تصدیق کننده</th>
      <th>تاریخ تصدیق</th>
      <th>توضیحات</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_DeviceBehfa
    |filter:Filter_Code_BEHFA:'codeBEHFA'
    |filter:Filter_Code_User:'username'
    |filter:Filter_Code_Group:'groupTitle'" >
    <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
    <td>{{item.code}}</td>
    <td>{{item.customerName}}</td>
    <td>{{item.persianDate}}</td>
    <td>{{item.groupTitle}}</td>
    <td>{{item.description}}</td>
    <td>{{item.manufacturer}}</td>
    <td>{{item.model}}</td>
    <td>{{item.codeBEHFA}}</td>
    <td>{{item.certificateNo}}</td>
    <td>{{item.calDue}}</td>
    <td>{{item.username}}</td>
    <td>{{item.downloadDate}}</td>
    <td>{{item.uploadDate}}</td>
    <td>{{item.confirmer}}</td>
    <td>{{item.confirmerDate}}</td>
    <td>{{item.dsc}}</td>
    </tr>
  </tbody>
</table>
